var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-card-title", { staticClass: "justify-center title-card" }, [
        _c("h2", [_vm._v("Esqueceu a senha?")])
      ]),
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          },
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "v-row",
            { staticClass: "flex-column mt-5", attrs: { align: "start" } },
            [
              _c(
                "v-col",
                { staticClass: "d-flex flex-column align-center py-0" },
                [
                  _c("span", { staticClass: "text-filelds" }, [
                    _vm._v("Por favor, informe seu email")
                  ])
                ]
              ),
              _c(
                "v-col",
                [
                  _c("v-text-field", {
                    staticClass: "input",
                    attrs: {
                      placeholder: "curtis.weaver@example.com",
                      rules: [
                        function(v) {
                          return !!v || "E-mail requerido"
                        }
                      ],
                      color: "secondary",
                      required: "",
                      outlined: "",
                      rounded: ""
                    },
                    model: {
                      value: _vm.email,
                      callback: function($$v) {
                        _vm.email = $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-btn",
        {
          staticClass: "my-4 btn-login py-3",
          attrs: {
            disabled: !_vm.valid,
            large: "",
            rounded: "",
            color: "success",
            loading: _vm.loading
          },
          on: { click: _vm.sendEmail }
        },
        [
          _c("p", { staticStyle: { color: "white", "margin-bottom": "0px" } }, [
            _vm._v("Enviar email")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }